// extracted by mini-css-extract-plugin
export default {"button":"_0d1fe44a0630affc"};